/**
 * TOUCHBeauty Multi Store Configuration
 *
 * Add new countries here in the future.
 *
 * Example:
 *
 * {
 *   code:"CA",
 *   name:"Canada",
 *   currency:"CAD",
 *   domain:"https://ca.touchbeauty.com",
 *   language:"en-CA",
 *   timezone:"America/Toronto"
 * }
 *
 */


window.TB_REGION_CONFIG = {


  defaultRegion: "US",



  stores: {


    US: {

      code: "US",

      name: "United States",

      shortName: "US",

      currency: "USD",

      symbol: "$",

      domain:
      "https://www.touchbeauty.com",

      language:
      "en-US",

      timezone:
      "America/New_York"

    },



    UK: {

      code: "UK",

      name: "United Kingdom",

      shortName: "UK",

      currency: "GBP",

      symbol: "£",

      domain:
      "https://touchbeauty.uk",

      language:
      "en-GB",

      timezone:
      "Europe/London"

    },



    JP: {

      code: "JP",

      name: "Japan",

      shortName: "Japan",

      currency: "JPY",

      symbol: "¥",

      domain:
      "https://www.touchbeauty.co.jp",

      language:
      "ja-JP",

      timezone:
      "Asia/Tokyo"

    }


  }



};